import React from 'react'
import Layout from '../components/layout'
import CsoundInstr from '../components/lib/csoundinstr'
import Components from '../components/lib/components'
import SuperGenetic from '../components/SuperGenetic'
import {Row, Col, Nav} from "react-bootstrap";
import {withPrefix} from 'gatsby';
import { Link } from 'gatsby'

class IndexPage extends React.Component {
  constructor() {
    super();
    this.inst = {
      components: [
        {
          type: "panel", id: "main", vertical: true, wrap: true, widgets: [
            {
              type: 'panel', id: 'geneticpanel', wrap:true, widgets: [
                {
                  id: 'st',
                  func: this.wtfunc.bind(this),
                  type: 'supergenetic',
                  label: 'supergenetic',
                  width: 400,
                  height: 400,
                  defval: {
                    x: 0,
                    y: 0,
                    rx: 0.5,
                    ry: 0.5,
                    m1: 4,
                    m2: 4,
                    n1: 0.3,
                    n2: 1,
                    n3: 1,
                    a: 1,
                    b: 1,
                    g0: 0,
                    g1: -1,
                    g2: -1,
                    g3: -1,
                    g4: -1,
                    g5: -1,
                    g6: -1,
                    g7: -1
                  }
                },
                {
                  type: 'panel', label: 'master', id: 'master', widgets: [
                    {id: 'amp', type: 'fader', label: 'amp', min: 0, max: 1, step: 0.01, defval: 0.6, height: 240, midictrl: 107},
                    {id: 'rev', type: 'fader', label: 'reverb', min: 0, max: 1, step: 0.01, defval: 0.6, height: 240},
                    {
                      id: 'filt',
                      type: 'fader',
                      label: 'filter',
                      log: true,
                      min: 40,
                      max: 15000,
                      step: 0.01,
                      defval: 10000,
                      height: 240,
                      size: 3
                    },
                    {
                      id: "ch",
                      type: "fader",
                      label: "rndch",
                      min: 0,
                      max: 1,
                      step: 0.01,
                      defval: 0,
                      height: 240,
                    },

                  ]
                }
              ]
            },
            {
              type: "panel", id: "ctrl", wrap: true, widgets: [
                Components.lfo("lfox", "lfo_x",5),
                Components.lfo("lfoy", "lfo_y",5),
                Components.lfo("lforx", "lfo_rx"),
                Components.lfo("lfory", "lfo_ry"),
                Components.lfo("lforot", "lfo_rot", 6.28),
                Components.lfo("lfon1", "lfo_n1"),
                Components.lfo("lfon2", "lfo_n2"),
                Components.lfo("lfon3", "lfo_n3"),
                Components.lfo("lfoa", "lfo_a"),
                Components.lfo("lfob", "lfo_b"),
                {
                  type: "panel", id: "adsrpanel", vertical: true, widgets: [
                    {
                      type: "adsr",
                      label: "adsr1",
                      id: "adsr1",
                      on: true,
                      defval: {adsr1_a: 0.01, adsr1_d: 0, adsr1_s: 1, adsr1_r: 0.1}
                    },
                    {
                      type: "adsr",
                      label: "adsr2",
                      id: "adsr2",
                      defval: {adsr2_a: 0.01, adsr2_d: 0.10, adsr2_s: 0, adsr2_r: 0}
                    },

                  ],
                },
              ]
            }
          ]
        }
      ]
    }
    this.tunings = [
      {
        name: 'blue',
        basekey: 0,
        basefreq: 8.25,
        scale: [1, 21 / 20, 10 / 9, 7 / 6, 5 / 4, 21 / 16, 7 / 5, 3 / 2, 25 / 16, 5 / 3, 7 / 4, 15 / 8]
      },
      {
        name: 'overtone',
        basekey: 0,
        basefreq: 8.25,
        scale: [1, 17 / 16, 9 / 8, 19 / 16, 5 / 4, 21 / 16, 11 / 8, 3 / 2, 13 / 8, 27 / 16, 7 / 4, 15 / 8]
      },
      {
        name: 'monte',
        basekey: 10,
        basefreq: 4.58333,
        scale: [1, 64 / 63, 9 / 8, 8 / 7, 7 / 6, 4 / 3, 21 / 16, 3 / 2, 32 / 21, 14 / 9, 16 / 9, 7 / 4]
      },
    ]
    this.csoundInstr = React.createRef();
    this.superTerrain = React.createRef();
  }

  onStart() {
    console.log("index on start");
    this.superTerrain.current.onStart();
  }

  wtfunc(component, changeFunc) {
    return (
      <SuperGenetic ref={ref => this.superTerrain.current = ref} cs={this.csoundInstr.current} def={component}
                    key={component.id} onChange={changeFunc}/>
    )
  }

  render() {

    return (
      <Layout>
        <Col>
          <Row>
            <Col><h3>genetic super terrain</h3></Col>
          </Row>
          <Row><Col> <CsoundInstr csoundwasm={withPrefix('csound.esm.js')}
                                  inst={this.inst} osc="gst" keyboard="gst"
                                  csd={withPrefix('geneticsuperterrain.csd')}
                                  tunings={this.tunings}
                                  plugins={[withPrefix('geneticsuperterrain.wasm')]}/>
          </Col>
          </Row>
        </Col>
      </Layout>
    )
  }
}

export default IndexPage
